import { Router } from "vue-router";
import { useAuthStore, useSettingStore, useTabStore } from "@/store";
import { isObject, restructureMeta } from "@/utils";

/** 处理菜单选中状态 */
function setMenuStatus(this: any, findMenu: { id: number; parentId: number }) {
  if (!isObject(findMenu)) return;
  this.setSelectedKeys([findMenu.id]);
}

/** 处理菜单打开状态 */
function setOpenStatus(this: any, findMenu: { id: number; parentId: number }) {
  if (!isObject(findMenu)) return;
  this.setOpenkeys([findMenu.id]);
}

//获取url所在对象
const getItemByUrl = (list: any[], url: string | number, level?: string) => {
  const isParent = level === "parent";
  const newArray: any[] = [];
  Array.isArray(list) &&
  list.length > 0 &&
  list.forEach((_) => {
    if (Array.isArray(_.childs) && _.childs.length > 0) {
      _.childs.forEach((v: any) => {
        newArray.push(v);
      });
    } else {
      newArray.push(_);
    }
  });
  const childMenu = newArray.find((item) => {
    return item.path === url;
  });
  return isParent ? list.find((_) => childMenu?.parentId === _.id) : childMenu;
};

// 记录上一次重定向的路径，防止循环重定向
let lastRedirectPath = '';
let redirectCount = 0;
const MAX_REDIRECTS = 10; // 最大重定向次数

const routerBefore = (router: Router) => {
  console.log("%c进入--------------------routerBefore", "color: blue; font-weight: bold;");
  
  // 定义白名单和404页面
  const whiteList = ["/login", "/404", "/401", "/register", "/reviewProgress", "/forgetPwd"];
  const notFoundPath = "/404"; // 404页面路径
  
  router.beforeEach((to, from, next) => {
    // 防止无限重定向
    if (to.path === lastRedirectPath) {
      redirectCount++;
      if (redirectCount > MAX_REDIRECTS) {
        console.error('检测到循环重定向，强制中断');
        lastRedirectPath = '';
        redirectCount = 0;
        return next(false);
      }
    } else {
      lastRedirectPath = to.path;
      redirectCount = 0;
    }

    // 白名单路由直接通过
    if (whiteList.includes(to.path)) {
      return next();
    }

    // 未登录情况处理
    if (!localStorage.getItem("token")) {
      console.log("未登录，重定向到登录页面");
      return next({ path: "/login" });
    }

    try {
      // 同步获取store，避免异步操作可能导致的问题
      const settingStore = useSettingStore();
      const tabStore = useTabStore();
      const authStore = useAuthStore();
      
      // 检查路由是否存在于菜单中
      const childMenu = getItemByUrl(authStore.menuList || [], to.path);
      
      // 如果路由不存在于菜单中且不在白名单中，重定向到404
      if (!childMenu && !router.hasRoute(to.name as string)) {
        console.warn(`路由 ${to.path} 不存在，重定向到404页面`);
        return next({ path: notFoundPath });
      }
      
      // 处理菜单和标签页
      if (childMenu) {
        const parentMenu = getItemByUrl(authStore.menuList || [], to.path, "parent");
        
        // 处理菜单选中状态
        setMenuStatus.call(settingStore, childMenu);
        if (parentMenu) {
          setOpenStatus.call(settingStore, parentMenu);
        }
      }
      
      // 添加到标签页
      tabStore.setTabs({ 
        name: to.name as string, 
        path: to.fullPath, 
        meta: restructureMeta(to) 
      });
      
      // 正常导航
      next();
    } catch (err) {
      console.error('路由守卫错误:', err);
      // 发生错误时，导航到首页或登录页
      next({ path: "/login" });
    }
  });
};

export default routerBefore;
